export default __webpack_public_path__ + "static/icon-tile-pairing-dont-7f8f944a8da6b95b39095aa86a3800c3.png";